import { setFavicon, setPageTitle } from '@hotjar/webapp/utils/document';

angular.module('hjApp').service('WindowTitle', function ($rootScope, $state, $window) {
    const DEFAULT_PAGE_TITLE = 'Hotjar';
    const FAVICONS = {
        DEFAULT: require('@hotjar/shared-assets/icons/favicon.ico'),
        PENDING: require('@hotjar/shared-assets/icons/favicon-pending.ico')
    };
    const FAVICON_TYPES = {
        default: 'default',
        pending: 'pending'
    };

    const formatPageTitle = (title) => {
        if (title === null) {
            return null;
        }

        return title ? `${title} - ${DEFAULT_PAGE_TITLE}` : DEFAULT_PAGE_TITLE;
    };

    const onWindowBlur = () => {
        const { blurTitle } = $state.current;

        if (!blurTitle) return;

        this.setRawTitle(blurTitle);
        this.setFavicon(FAVICON_TYPES.pending);
    };

    const onWindowFocus = () => {
        this.update();
    };

    this.update = () => {
        const { title, favicon } = $state.current;
        this.setTitle(title);
        this.setFavicon(favicon || FAVICON_TYPES.default);
    };

    this.setRawTitle = (title = DEFAULT_PAGE_TITLE) => {
        this.title = title;
        setPageTitle(title);
        $rootScope.$applyAsync();
    };

    this.setTitle = (title) => {
        this.title = formatPageTitle(title);

        setPageTitle(this.title);
        $rootScope.$applyAsync();
    };

    this.setFavicon = (type = 'default') => {
        switch (type) {
            case FAVICON_TYPES.pending:
                this.favicon = FAVICONS.PENDING;
                break;
            default:
                this.favicon = FAVICONS.DEFAULT;
                break;
        }

        setFavicon(this.favicon);

        $rootScope.$applyAsync();
    };

    const handleVisibilityChange = () => {
        if ($window.document.visibilityState === 'visible') {
            onWindowFocus();
        } else {
            onWindowBlur();
        }
    };

    angular.element($window.document).on('visibilitychange', () => handleVisibilityChange());

    $rootScope.$on('$stateChangeSuccess', () => this.update());
});
